import { selectorFamily } from "recoil"
import { TeamMemberContacts } from "src/types/contact/TeamMemberContact"
import { teamMemberContactsRequestIdState } from "src/recoil/atoms/contact/teamMemberContactsRequestIdState"
import { contactDetailCacheSkipState } from "src/recoil/atoms/contact/contactDetailCacheSkipState"
import { tokensState } from "src/recoil/atoms/authorization/tokensState"
import { getTeamMemberContacts } from "src/apis/contact/getTeamMemberContacts"
import { CustomAlert } from "src/utils/CustomAlert"
import { Platform } from "react-native"
import { CustomAlert as AppAlert } from "src/utils/CustomAlert/index.native"
import { ContactType } from "src/constants/ContactType"
import { ContactListCacheService } from "src/services/cache/ContactListCacheService"

export const teamMemberContactsSelectorFamily = selectorFamily<
  TeamMemberContacts | undefined,
  { contactId: string | undefined; type: "Inbox" | "Outbox" | "Reserved" | "Migration" }
>({
  key: "selectors/contact/teamMemberContactsSelectorFamily",
  get:
    ({ contactId, type }) =>
    async ({ get }) => {
      if (!(type === "Inbox" || type === "Outbox" || type === "Reserved")) return undefined
      // requestIdを監視（リフレッシュ時にRecoilが再評価をトリガー）
      const requestId = get(teamMemberContactsRequestIdState)
      // キャッシュスキップフラグを監視（Pull-to-Refresh時にキャッシュをスキップ）
      const skipCache = get(contactDetailCacheSkipState)

      const tokens = get(tokensState)
      const accessToken = tokens?.accessToken
      if (accessToken == null || contactId == null) {
        return
      }

      // キャッシュチェック
      // skipCache: 明示的なキャッシュスキップフラグ（Pull-to-Refresh時にtrue）
      // requestId: キャッシュ保存時のrequestIdと比較してキャッシュの有効性を判断
      const cached = ContactListCacheService.getTeamMemberContacts({
        contactId,
        type,
      })

      // キャッシュを使用する条件:
      // 1. skipCacheがfalse（初回ロード時/Pull-to-Refresh時はtrue）
      // 2. キャッシュが存在する
      // Note: skipCacheのデフォルト値はtrue。初回ロード完了後にfalseに設定される。
      //       これによりブラウザリロード時は常に最新データをAPIから取得する。
      if (!skipCache && cached) {
        return cached.data
      }
      const result = await getTeamMemberContacts({ accessToken, contactId, type })
      if (!result.isOk) {
        if (Platform.OS === "web") {
          await CustomAlert.alert("エラー", result.error.message)
        } else {
          await AppAlert.alert("エラー", result.error.message)
        }

        return { contactType: ContactType.Normal, items: [] }
      }

      // キャッシュに保存
      ContactListCacheService.setTeamMemberContacts({ contactId, type }, result.content)

      return result.content
    },
})
